<top-banner variant="title" [title]="'Site Form - ' + siteFormResponse?.form.name"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">

          <div class="row animated fadeIn">
            <!-- side menu -->
            <div class="col-md-2 cardtabs-wrapper">

              <nav class="nav cardtabs flex-column">
                <!-- todo: fix css class -->
                <div class="back-and-menu-link">
                  <a *ngIf="workOrderId && siteFormResponse" [routerLink]="['/', routeRole, 'sites', siteFormResponse.site.id, 'work-orders', workOrderId]" class="nav-link back-link">back</a>
                  <a *ngIf="!workOrderId" [routerLink]="['/', routeRole, 'site-forms', siteFormId]" class="nav-link back-link">back</a>
                  <p></p>
                </div>
              </nav>
            </div>

            <!-- main area -->
            <div class="col-md-10 mb-2">
              <h4 *ngIf="siteFormResponse" class="card-title">{{siteFormResponse.form.name}}</h4>

              <div *ngIf="siteFormResponse">
                <dl class="sideways-dl">
                  <div>
                    <dt>Completed by</dt>
                    <dd>{{siteFormResponse.user.fullName}}<span *ngIf="siteFormResponse.submittedBy">&nbsp;(Submitted by {{ siteFormResponse.submittedBy }})</span></dd>
                  </div>
                  <div>
                    <dt>Date</dt>
                    <dd>
                      <date-friendly [value]="siteFormResponse.createdDate"></date-friendly>
                    </dd>
                  </div>
                  <div>
                    <dt>Site</dt>
                    <dd>{{siteFormResponse.site.name}}</dd>
                  </div>
                  <div>
                    <dt>Site Owner</dt>
                    <dd>{{ siteFormResponse.form.siteOwnerName }}</dd>
                  </div>
                  <div *ngIf="siteFormResponse.workOrder">
                    <dt>Work Order</dt>
                    <dd><a [routerLink]="['/', routeRole, 'sites', siteFormResponse.site.id, 'work-orders', siteFormResponse.workOrder.id]">{{'WRK ' + siteFormResponse.workOrder.id}}</a></dd>
                  </div>
                </dl>
                <br>
                <div *ngIf="siteFormResponse.attachments.length">
                  <h6>Attached Documents</h6>
                  <div *ngFor="let file of siteFormResponse.attachments" class="file-list-item">
                    <p>
                      {{ file | fileName }}
                    </p>
                    <div class="file-list-links">
                      <button type="button" class="btn btn-primary btn-link" (click)="openAttachment(file)">view</button>
                    </div>
                  </div>
                </div>
              </div>

              <hr>
              <br>
              <br>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group form-group-checkbox mt-0">
                    <label>Include photos?</label>
                    <p-checkbox class="form-control" [(ngModel)]="includePhotos" (ngModelChange)="downloadClicked = false" binary="true"></p-checkbox>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mb-3">

                <button [disabled]="isLoading || downloadClicked" class="btn btn-primary" (click)="downloadPDF()">Download PDF</button>
              </div>

            </div>
          </div>

          <div class="row animated fadeIn">
            <div class="col-md-12">
              <site-form-response-preview-pane *ngIf="!isLoading" [logoUrl]="logoUrl" [siteFormResponse]="siteFormResponse" [includePhotos]="includePhotos"></site-form-response-preview-pane>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

